import { Breadcrumbs } from "../Breadcrumbs/Breadcrumbs";

export const Main = ({ children }) => {
	return (
		<>
			<Breadcrumbs />
			<main className="main">{children}</main>
		</>
	);
};
